/**
 * Adds a method for tracking for GP (currently used for GTM custom events)
 */
import CommMixin from "./CommMixin";
var TrackMixin = {
  mixins: [CommMixin],
  data: function () {
    return {
      TRACK_CLICK: "click_",
      TRACK_CHOICE: "select_",
      TRACK_INPUT: "input_",
      TRACK_SEARCH: "search_",
    };
  },
  methods: {
    trackEvent: function (type, id, info) {
      if (id) {
        var dataLayer = { type, id };
        if (info) dataLayer = { ...dataLayer, info };
        this.broadcast("rb-track", dataLayer);
      }
    },
    getTrackId: function (event) {
      if (event && event.currentTarget) {
        return event.currentTarget.id;
      }
      return null;
    },
    getTrackData: function (event) {
      if (event && event.currentTarget) {
        return {
          [event.currentTarget.dataset.trackType]:
            event.currentTarget.dataset.trackValue,
        };
      }
      return null;
    },
    deuniquefyId: function (id) {
      if (id && id.indexOf("--")) {
        var parts = id.split("--");
        return parts[0];
      }
      return id;
    },
    formatTracking(id, trackType = null) {
      if (!id) return null;
      var tempId = this.deuniquefyId(id);
      tempId = tempId.replace(/-/gi, "_");
      return `${trackType ? trackType : this.TRACK_CHOICE}${tempId}`;
    },
    getTrackingOption: function (mappings, id) {
      var option = mappings.find((mapping) => mapping.id === id);
      if (option) return option.as;
      return id;
    },
  },
};

export default TrackMixin;
